/** Public destinations shared by SSR, the rollback storefront and the sitemap. */
export const CONTENT_PAGES = [
  {
    key: 'home',
    path: '/',
    title: 'home',
    lead: 'about',
    sections: [
      'about',
      'craft',
      'regions',
      'production',
      'history',
      'subscription',
      'gifts',
      'events',
      'social',
      'welcome',
    ],
  },
  {
    key: 'teaClub',
    path: '/tea-club',
    title: 'teaClub',
    lead: 'club',
    sections: ['clubActivities', 'clubPeople', 'subscription', 'clubApp'],
  },
  {
    key: 'events',
    path: '/events',
    title: 'events',
    lead: 'events',
    sections: ['clubActivities', 'clubPeople'],
  },
  {
    key: 'partnership',
    path: '/partnership',
    title: 'partnership',
    lead: 'partnership',
    sections: ['restaurants', 'hotels', 'shops', 'corporate', 'partnerApp'],
  },
  {
    key: 'delivery',
    path: '/delivery',
    title: 'delivery',
    lead: 'delivery',
    sections: ['orderSteps', 'shipping', 'payment', 'app'],
  },
  {
    key: 'about',
    path: '/about',
    title: 'about',
    lead: 'about',
    sections: ['craft', 'regions', 'production', 'history', 'welcome'],
  },
  {
    key: 'contacts',
    path: '/contacts',
    title: 'contacts',
    lead: 'contacts',
    sections: ['contactTopics', 'visit', 'app'],
  },
  { key: 'gifts', path: '/gifts', title: 'gifts', lead: 'gifts', sections: ['giftApp', 'app'] },
  {
    key: 'production',
    path: '/articles/tea-production',
    title: 'about',
    lead: 'production',
    sections: ['craft'],
    article: true,
  },
  {
    key: 'history',
    path: '/articles/georgian-tea-history',
    title: 'about',
    lead: 'history',
    sections: [],
    article: true,
  },
  {
    key: 'regions',
    path: '/articles/tea-regions',
    title: 'about',
    lead: 'regions',
    sections: [],
    article: true,
  },
  {
    key: 'hydrolats',
    path: '/articles/hydrolats',
    title: 'gifts',
    lead: 'hydrolats',
    sections: [],
    article: true,
  },
] as const;
export type ContentPageKey = (typeof CONTENT_PAGES)[number]['key'];
export const MAIN_NAVIGATION = [
  { key: 'home', path: '/' },
  { key: 'catalog', path: '/catalog' },
  { key: 'teaClub', path: '/tea-club' },
  { key: 'events', path: '/events' },
  { key: 'partnership', path: '/partnership' },
  { key: 'delivery', path: '/delivery' },
  { key: 'about', path: '/about' },
  { key: 'contacts', path: '/contacts' },
] as const;
export const PUBLIC_CONTENT_PATHS = ['/catalog', ...CONTENT_PAGES.map((page) => page.path)];

export interface WebsiteContentLinks {
  phone: string;
  email: string | null;
  telegram: string | null;
  instagram: string | null;
  miniapp: string | null;
  partnershipEnabled: boolean;
}
export const DEFAULT_CONTENT_LINKS: WebsiteContentLinks = {
  phone: '+995595116752',
  email: null,
  telegram: null,
  instagram: null,
  miniapp: null,
  partnershipEnabled: false,
};
